import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';

const OtpRedirect = () => {
  const location = useLocation();
  const history = useHistory();
  const values = queryString.parse(location.search);

  // console.log('values', values);

  const responseDecoded = window.atob(values.r);

  sessionStorage.setItem('otpData', responseDecoded);

  history.push('/');

  return <div />;
};

export default OtpRedirect;
